import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink,Router, RouterLinkActive } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { DBUpdateMessage } from '../libs/ceeyu-common/src';
import { DbService, RegistrationEvent } from '../service/db-service.service';
import { firstValueFrom, Observable } from 'rxjs';

import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from '@angular/material/datepicker';
import { MatInput } from '@angular/material/input';
import { IRegistrationEntry } from '../models/registrationentry.model';
import { IRegistrationEvent } from '../models/registrationevent.model';
import { IUserParam } from '../models/userparam.model';
import { Store } from '@ngrx/store';
import { IAppState } from '../models/app.state.model';
import { MatDialogModule, MatDialog, MatDialogConfig, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
@Component({
    selector: 'ceeyu-createnewevent',
    templateUrl: './createnewevent.component.html',
    styleUrls: ['./createnewevent.component.scss'],
    providers: [ 
      {provide: DateAdapter, useClass: NativeDateAdapter},
      {provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS}
    ],
    imports: [MatDialogModule, MatDialogContent, MatDialogActions,FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatSuffix, MatDateRangePicker, MatError, MatInput]
})
export class CreateneweventComponent implements OnInit {
   @ViewChild('successfullyCreated') successfullyCreated!: TemplateRef<any>;
  hide = true;
  message = "Welcome";
  errormessage = "";
  founderror = false;
  statefound = false;
  event: RegistrationEvent;
  firebaseMessage: DBUpdateMessage;
  personid: string;
  visitorName: string;
  bk: string;
  phone: string;
  spemail: string;
  spname: string;
  neweventform: FormGroup;
  imgStatus: Map<string, string> = new Map();
  min = null;
  max = null;
  state: any;
  public userParamData$: Observable<IUserParam[]> = this.store.select((store) => store.userParam);
  public registrationEntryData$: Observable<IRegistrationEntry[]> = this.store.select((store) => store.registrationEntry);
  public registrationEventData$: Observable<IRegistrationEvent[]> = this.store.select((store) => store.registrationEvent); 
 
  constructor(public  _dateAdapter: DateAdapter<Date>, private dialog: MatDialog, private store: Store<IAppState>, public dbService: DbService,private router:Router, private http: HttpClient,
    private formBuilder: FormBuilder) { 
    this.firebaseMessage = new DBUpdateMessage();
    this.min = this._dateAdapter.today();
    this.max = this._dateAdapter.addCalendarDays(this.min, 7);
    console.log("create new event:" + JSON.stringify(router.getCurrentNavigation().extras));
    
  }

  ngOnInit(): void {
      console.log("ngOnInit of CreateneweventComponent");
      this.userParamData$.subscribe((data) => {
      //console.log("userParamData$: ", JSON.stringify(data));
      if(data && data.length > 0){
        this.visitorName = data[0].visitorName;
        this.phone = data[0].phone;
        this.spemail = data[0].spemail;
        this.spname = data[0].spname;
        this.bk = data[0].personid;
        this.personid = data[0].personid;
      }
      this.event = new RegistrationEvent();
      this.event.spphone = this.phone;
      this.event.spemail = this. spemail;
    });
    this.registrationEntryData$.subscribe((data) => {
      //console.log("registrationEntryData$: ", JSON.stringify(data));
    });
    
    this.neweventform = this.formBuilder.group({
        formControltitle: ['', [Validators.required]],
        formControlspname: [this.visitorName, [Validators.required]],
        formControlspphone: [this.phone, [Validators.required]],
        formControlspemail: [this.spemail, [Validators.required]],
        fromdate: [this.min, [Validators.required]],
        todate: [this.max, Validators.required]
      }
	  ); 
  }

  async onSubmit(){
      console.log("onsubmit clicked!!!");
      console.log("Errors:" + this.neweventform.valid);
      console.log(this.neweventform.errors);
      console.log(this.neweventform);
      this.founderror = false;
      if(!this.neweventform.valid){
        this.errormessage = "Please correct the errors and try again.";
        this.founderror = true;
      }
      console.log("no errors found: calling populate")
      if(!this.founderror){
        this.populate();
        //this.router.navigate(['confirmevent'], { skipLocationChange: true, state: {event:this.event}});
        //this.router.navigate(['inviteattendee'], { skipLocationChange: true,state: {mode: 'addatt', myphone:this.phone, eventid: this.event.docid, title: this.event.title}});
       this.message = "Please wait...";
       //this.firebaseMessage.code = -1;
      
       firstValueFrom(this.dbService.processEventCreate(this.event,this.dbService.bk,"newevent",this.phone, this.spemail,this.visitorName, this.http))
       .then((response) => {
         //  this.event.docid = response["docid"];
           this.dbService.parsePostReponse(this.firebaseMessage, response);
           this.message = this.firebaseMessage.message;
           this.openCreatedDialog();
          
           //console.log("return code:" + this.firebaseMessage.code)
         })
         .then((resp) => {
            console.log("resp is:" + resp);
            this.updatepl();
         }) 
         .catch((err) => {
           console.log("error", err);
         })
      }
  }

  openCreatedDialog(){
    const dialogRef = this.dialog.open(this.successfullyCreated);
    dialogRef.afterClosed().subscribe(()=>{
       this.router.navigate(['inviteattendee'], { skipLocationChange: true, state: {mode: 'addatt', spname: this.visitorName, bk: this.personid, spphone:this.phone, spemail: this.spemail, eventid: this.event.docid, title: this.event.title, fromdate: this.event.fromdate, todate: this.event.todate}});
    })
  }
  
  updatepl(){
    this.dbService.updatepl(this.event.docid, this.event.spphone.replace("+","p"), this.http)
    .then((resp) => {
      console.log("updatepl resp is:" + JSON.stringify(resp));
      this.dbService.eventInitComplete = true; 
      this.router.navigate(['inviteattendee'], { skipLocationChange: true, state: {mode: 'addatt', spname: this.visitorName, spphone:this.phone, eventid: this.event.docid, title: this.event.title}});
   })
   .catch((err) => {
     console.log("error", err);
   })
  }

  populate(){
      this.event.title = this.neweventform.get('formControltitle').value;
      this.event.spname = this.neweventform.get('formControlspname').value;
      this.event.fromdate = this.neweventform.get('fromdate').value;
      this.event.todate = this.neweventform.get('todate').value;
      this.event.docid = this.randomString(12);
      this.event.bk = this.dbService.bk;
      this.dbService.selectedEvent = this.event;
  }
  
  getErrorMessage() {
    const email = this.neweventform.get("formControlName");
    if (email.hasError('required')) {
      return 'You must enter a value';
    }
    return email.hasError('email') ? 'Not a valid email' : '';
  }

 
  randomString(len) {
    const charSet = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const title = this.event.title;
    const temp  = title.replace("goo","");
    const temp2 = temp.replace("goog","");
    const temp3 = temp2.replace("gle","");
    let randomString = (temp3.replace(/\s/g, "")) + "_";
    for (let i = 0; i < len; i++) {
        const randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz,randomPoz+1);
    }
    return randomString;
  }
}
